module.exports = __webpack_public_path__ + "static/media/Vibin_Resume.2c5166d5.pdf";